import React from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { IconButton } from "features/../../../shared/components/buttons";
import Add from "features/../../../shared/assets/white-add.svg";
import ReturnOnInvestmentForm from "./ReturnOnInvestmentForm";
import { addReturnOnInvestment } from "./actions";

const AddReturnOnInvestmentModal = ({ onSubmitted, dealerOfficeId }) => (
  <PermissionCheck target={Targets.ReturnOnInvestment} action={Actions.Create}>
    <ModalBuilder
      withForm
      submitAction={addReturnOnInvestment}
      submitParams={{ dealerOfficeId }}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) => (
        <IconButton icon={Add} primary content="New ROI" onClick={showModal} />
      )}
      renderModal={(modalProps, formProps) => (
        <Modal.Add
          {...modalProps}
          size="small"
          header="Add ROI"
          submitLabel="Create ROI"
        >
          <ReturnOnInvestmentForm
            formProps={formProps}
            dealerOfficeId={dealerOfficeId}
          />
        </Modal.Add>
      )}
    />
  </PermissionCheck>
);

export default AddReturnOnInvestmentModal;
